'use client'

import { useQuery } from '@tanstack/react-query'

import { SyneriseCampaignRecommendationQueryParams } from 'lib/synerise'
import { QueryKey } from 'shared/api'

import { getRecommendedSimilarItemProducts } from '../api/recommendations'
import { ProductTypes } from '../types/products'

interface UseQueryRecommendedSimilarItemProductsProps {
  token: string
  product: ProductTypes | null
  distributionCenterId: string
}

const useQueryRecommendedSimilarItemProducts = ({
  token,
  product,
  distributionCenterId
}: UseQueryRecommendedSimilarItemProductsProps) => {
  const productId = product ? product.id : ''
  const categoryId = product?.categoriesTree?.[0]?.id ?? ''

  const syneriseRecommendationQueryParams: SyneriseCampaignRecommendationQueryParams =
    {
      itemId: product?.code
    }

  return useQuery({
    queryKey: [QueryKey.recommendedSingleItemProducts, token, productId],
    queryFn: () =>
      getRecommendedSimilarItemProducts({
        token,
        productId,
        categoryId,
        distributionCenterId,
        syneriseRecommendationQueryParams
      }),
    staleTime: 1000 * 60 // 1 minute
  })
}

export default useQueryRecommendedSimilarItemProducts
